export default __webpack_public_path__ + "static/media/close-kedi-sag.fb247e7c.png";